import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../images/site_logo/site_logo_1.svg";
import MobileMenu from "../MobileMenu/MobileMenu";

const Header = (props) => {
  const [mobileActive, setMobileState] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const [loginDropdownOpen, setLoginDropdownOpen] = useState(false);
  const [auctionsOpen, setAuctionsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const auctionsRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    // Handle click outside to close dropdown
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setLoginDropdownOpen(false);
      }
      if (auctionsRef.current && !auctionsRef.current.contains(event.target)) {
        setAuctionsOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
    // Close mobile menu when clicking on a link
    setMobileState(false);
    // Close login dropdown
    setLoginDropdownOpen(false);
    // Close auctions dropdown
    setAuctionsOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileState(!mobileActive);
    // Close login dropdown when opening mobile menu
    if (!mobileActive) {
      setLoginDropdownOpen(false);
    }
  };

  const toggleLoginDropdown = () => {
    setLoginDropdownOpen(!loginDropdownOpen);
  };

  const toggleAuctionsDropdown = (event) => {
    event.preventDefault();
    setAuctionsOpen((prev) => !prev);
  };

  const handleLoginOptionClick = (option) => {
    ClickHandler();
    
    // Navigate to appropriate page and scroll to login section
    switch(option) {
      case 'customer':
        // Navigate to /sign_in and scroll to login section
        window.location.href = '/sign_in#customer-login';
        break;
      case 'business':
        // Navigate to /work-with-tcuk and scroll to business login
        window.location.href = '/work-with-tcuk#business-login';
        break;
      case 'business-agents':
        // Navigate to /work-with-tcuk and scroll to business agents login
        window.location.href = '/work-with-tcuk#business-agent-login';
        break;
        case 'member':
        // Navigate to /member-login and scroll to member login
        window.location.href = '/member-login';
        break;
        case 'admin':
        // Navigate to /account-admin-login and scroll to account admin login
        window.location.href = '/account-admin/login';
        break;
      default:
        break;
    }
  };

  return (
    <header className={`site_header  ${isSticky ? "sticky" : ""}`} style={{background:"#021A62"}}>
      <div className="nav_wrapper">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-2 col-5 d-flex align-items-center">
              <div className="site_logo">
                <NavLink className="site_link" to="/" onClick={ClickHandler}>
                  <img loading="lazy" src={Logo} alt="TopCoin Uk" />
                </NavLink>
              </div>
            </div>
            <div className="col-lg-9 col-2">
              <nav className="main_menu navbar navbar-expand-lg">
                <div
                  className={`main_menu_inner collapse navbar-collapse justify-content-center ${
                    mobileActive ? "show" : ""
                  }`}
                  id="main_menu_dropdown"
                >
                  <ul className="main_menu_list unordered_list text-uppercase main-menu d-none d-lg-flex">
                    <li>
                      <NavLink
                        to="/"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="nav-link scrollspy_btn"
                        onClick={ClickHandler}
                      >
                        <span className="nav_link_label" data-text="Home">
                          Home
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/about"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="nav-link scrollspy_btn"
                        onClick={ClickHandler}
                      >
                        <span className="nav_link_label" data-text="About">
                          About
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/sign_in"
                      >
                        <span
                          className="nav_link_label"
                          data-text="CUSTOMERS & AGENTS"
                        >
                          CUSTOMERS & AGENTS
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/work-with-tcuk"
                      >
                        <span
                          className="nav_link_label"
                          data-text="BUSINESSES & AGENTS"
                        >
                          BUSINESSES & AGENTS
                        </span>
                      </NavLink>
                    </li>
                    
                    
                    <li>
                      <NavLink
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/active-retailers"
                      >
                        <span className="nav_link_label" data-text="Active Retailers">
                          Active Retailers
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/tuck-units"
                      >
                        <span
                          className="nav_link_label"
                          data-text="TCUK Wallets"
                        >
                          TCUK Wallets
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <a
                        onClick={ClickHandler}
                        className="nav-link"
                        href="https://stagingcollectible.topcoinuk.com/"
                      >
                        <span
                          className="nav_link_label"
                          data-text="CAPTAIN TC REWARD CARDS"
                        >
                          CAPTAIN TC REWARD CARDS
                        </span>
                      </a>
                    </li>
                    {/* <li
                      className={`menu-item-has-children ${auctionsOpen ? "active" : ""}`}
                      ref={auctionsRef}
                      style={{ position: "relative" }}
                    >
                      <button
                        type="button"
                        onClick={toggleAuctionsDropdown}
                        className="nav-link"
                        aria-expanded={auctionsOpen}
                        aria-haspopup="true"
                        style={{ background: "none", border: "none", padding: 0, display: "flex", alignItems: "center" }}
                      >
                        <span
                          className="nav_link_label"
                          data-text="AUCTIONS & SALES"
                        >
                          AUCTIONS & SALES
                        </span>
                        <i
                          className={`fa ${auctionsOpen ? "fa-angle-up" : "fa-angle-down"}`}
                          style={{ marginLeft: 8, fontSize: "14px" }}
                          aria-hidden="true"
                        ></i>
                      </button>
                      <ul
                        className="submenu auctions-submenu"
                        style={{
                          display: auctionsOpen ? "block" : "none",
                          listStyle: "none",
                          padding: 10,
                          margin: 0,
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          minWidth: "220px",
                          zIndex: 1000,
                          background: "#021A62",
                          boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                          borderRadius: "6px",
                          border: "1px solid #4d4b4b",
                          // color: "var(--white)",
                          fontSize: "14px",
                        }}
                      >
                        <li style={{ padding: "6px 10px", marginBottom: "0px", borderBottom: "1px solid #636161" }}>
                          <NavLink
                            onClick={ClickHandler}
                            className="nav-link"
                            to="/auctions-sales/retail-auctions"
                          >
                            <span
                              className="nav_link_label"
                              data-text="TCUK Retail Auctions"
                            >
                              TCUK Retail Auctions
                            </span>
                          </NavLink>
                        </li>
                        <li style={{ padding: "6px 10px", marginBottom: "0px", borderBottom: "1px solid #636161" }}>
                          <NavLink
                            onClick={ClickHandler}
                            className="nav-link"
                            to="/auctions-sales/property-auctions"
                          >
                            <span
                              className="nav_link_label"
                              data-text="TCUK Property Auctions"
                            >
                              TCUK Property Auctions
                            </span>
                          </NavLink>
                        </li>
                        <li style={{ padding: "6px 10px", marginBottom: "0px", borderBottom: "1px solid #636161" }}>
                          <NavLink
                            onClick={ClickHandler}
                            className="nav-link"
                            to="/auctions-sales/car-auctions"
                          >
                            <span
                              className="nav_link_label"
                              data-text="TCUK Car Auctions"
                            >
                              TCUK Car Auctions
                            </span>
                          </NavLink>
                        </li>
                        <li style={{ padding: "6px 10px", marginBottom: "0px", borderBottom: "1px solid #636161" }}>
                          <NavLink
                            onClick={ClickHandler}
                            className="nav-link"
                            to="/auctions-sales/property-sales"
                          >
                            <span
                              className="nav_link_label"
                              data-text="TCUK Property Sales"
                            >
                              TCUK Property Sales
                            </span>
                          </NavLink>
                        </li>
                        <li style={{ padding: "6px 10px", marginBottom: "0px" }}>
                          <NavLink
                            onClick={ClickHandler}
                            className="nav-link"
                            to="/auctions-sales/car-sales"
                          >
                            <span
                              className="nav_link_label"
                              data-text="TCUK Car Sales"
                            >
                              TCUK Car Sales
                            </span>
                          </NavLink>
                        </li>
                      </ul>
                    </li> */}
                  </ul>

                  {/* Mobile Menu - Only show when active */}
                  {mobileActive && <MobileMenu onLinkClick={ClickHandler} />}
                </div>
              </nav>
            </div>
            <div className="col-lg-1 col-5 " >
              <ul className="btns_group unordered_list p-0 justify-content-end align-items-center">
                <li className="d-lg-none">
                  <button
                    className="mobile_menu_btn"
                    type="button"
                    aria-expanded={mobileActive}
                    aria-label="Toggle navigation"
                    onClick={toggleMobileMenu}
                  >
                    <i
                      className={`far ${mobileActive ? "fa-times" : "fa-bars"}`}
                    ></i>
                  </button>
                </li>
                {/* Login Button with Dropdown - Show on both desktop and mobile */}
                <li className="position-relative" ref={dropdownRef}>
                  <button
                    onClick={toggleLoginDropdown}
                    className="ico_btn_outline"               
                  >
                    <span className="ico_btn_label">Login</span>
                  {/*   <i className={`fas ${loginDropdownOpen ? "fa-chevron-up" : "fa-chevron-down"}`}></i> */}
                  </button>
                  
                  {/* Login Dropdown Menu */}
                  {loginDropdownOpen && (
                    <div className=" main_menu_list unordered_list text-uppercase"
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        minWidth: "200px",
                        zIndex: 1000,
                        marginTop: "8px",
                        padding: "8px 0",
                      }}
                    >
                      <ul className="p-0 m-0 " style={{ listStyle: "none" }}>
                        <li>
                          <button
                            onClick={() => handleLoginOptionClick('customer')}
                            style={{
                              width: "100%",
                              textAlign: "left",
                              padding: "12px 16px",
                              background: "none",
                              border: "none",
                              borderBottom: "1px solid #eee",
                              cursor: "pointer",
                              color: "var(--bs-dark)",
                              transition: "background 0.2s",
                              fontWeight:"500",
                              fontSize:"15px"
                            }}
                            onMouseEnter={(e) => e.target.style.background = "#f5f5f5"}
                            onMouseLeave={(e) => e.target.style.background = "transparent"}
                          >
                           AS CUSTOMER/AGENT
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => handleLoginOptionClick('business')}
                            style={{
                              width: "100%",
                              textAlign: "left",
                              padding: "12px 16px",
                              background: "none",
                              border: "none",
                              borderBottom: "1px solid #eee",
                              cursor: "pointer",
                              color: "var(--bs-dark)",
                              transition: "background 0.2s",
                              fontWeight:"500",
                              fontSize:"15px"
                            }}
                            onMouseEnter={(e) => e.target.style.background = "#f5f5f5"}
                            onMouseLeave={(e) => e.target.style.background = "transparent"}
                          >
                            AS BUSINESS
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => handleLoginOptionClick('business-agents')}
                            style={{
                              width: "100%",
                              textAlign: "left",
                              padding: "12px 16px",
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              color: "var(--bs-dark)",
                              transition: "background 0.2s",
                              fontWeight:"500",
                              fontSize:"15px"
                            }}
                            onMouseEnter={(e) => e.target.style.background = "#f5f5f5"}
                            onMouseLeave={(e) => e.target.style.background = "transparent"}
                          >
                            AS BUSINESS AGENT
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => handleLoginOptionClick('member')}
                            style={{
                              width: "100%",
                              textAlign: "left",
                              padding: "12px 16px",
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              color: "var(--bs-dark)",
                              transition: "background 0.2s",
                              fontWeight:"500",
                              fontSize:"15px"
                            }}
                            onMouseEnter={(e) => e.target.style.background = "#f5f5f5"}
                            onMouseLeave={(e) => e.target.style.background = "transparent"}
                          >
                            AS MEMBER
                          </button>
                        </li>
                         <li>
                          <button
                            onClick={() => handleLoginOptionClick('admin')}
                            style={{
                              width: "100%",
                              textAlign: "left",
                              padding: "12px 16px",
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              color: "var(--bs-dark)",
                              transition: "background 0.2s",
                              fontWeight:"500",
                              fontSize:"15px"
                            }}
                            onMouseEnter={(e) => e.target.style.background = "#f5f5f5"}
                            onMouseLeave={(e) => e.target.style.background = "transparent"}
                          >
                            AS ACCOUNT ADMIN
                          </button>
                        </li>
                      </ul>
                    </div>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Overlay for mobile menu */}
      {mobileActive && (
        <div
          className="mobile-menu-overlay"
          onClick={() => setMobileState(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
            display: "none",
          }}
        ></div>
      )}
      
      <style>{`
        @media (min-width: 992px) {
          .header_Menu_Size {
              flex: 0 0 auto;
              width: 80%;
            }
        }

        .auctions-submenu li a {
          color: var(--white);
          display: block;
          transition: color 0.2s ease;
        }

        // .auctions-submenu li:hover {
        //   background: transparent;
        // }

        .auctions-submenu li:hover a,
        .auctions-submenu li a:hover {
          color: #0d6efd;
        }
        
        /* Mobile dropdown styles */
        @media (max-width: 991px) {
          .login-dropdown-menu {
            position: fixed !important;
            top: 60px !important;
            right: 15px !important;
            left: 15px !important;
            min-width: auto !important;
            width: calc(100% - 30px) !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;